module.exports = __webpack_public_path__ + "img/1678693937569588.71103251.png";